import {
  Network,
  MonitorCheck,
  ShieldCheck,
  LockKeyhole,
} from 'lucide-react';
import { Service, ContactInfo, NavItem } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Inicio', href: '#home' },
  {
    label: 'Servicios',
    href: '#services',
    /* children: [
      {
        label: 'Infraestructura y Redes',
        href: '#',
        children: [
          { label: 'Ingeniería Telemática', href: '#services-telematica' },
          { label: 'Telefonía VOZ/IP', href: '#services-voip' },
          { label: 'Redes de Voz y Datos', href: '#services-infraestructura' }
        ]
      },
      {
        label: 'Seguridad y Vigilancia',
        href: '#',
        children: [
          { label: 'Ciberseguridad', href: '#services-seguridad' },
          { label: 'CCTV y Videovigilancia', href: '#services-seguridad' },
          { label: 'Control de Accesos', href: '#services-accesos' }
        ]
      },
      {
        label: 'Gestión y Soporte',
        href: '#',
        children: [
          { label: 'Soporte IT / ERP', href: '#services-soporte' },
          { label: 'Disaster Recovery', href: '#services-datos' },
          { label: 'Climatización e Incendios', href: '#services-infraestructura' }
        ]
      }
    ] */
  },
  { label: 'Sobre Nosotros', href: '#about' },
  { label: 'Contáctanos', href: '#contact' },
];

export const SERVICES: Service[] = [
  {
    id: 'infraestructura',
    title: 'Infraestructura y Redes IP',
    description: 'Ingeniería telemática especializada en diseño de redes, fibra óptica y soluciones de telefonía Voz/IP para una conectividad robusta.',
    icon: Network,
    image: '/assets/service_redes.webp',
    mobileImage: '/assets/service_redes_movil.webp'
  },
  {
    id: 'soporte',
    title: 'Soporte e Integración',
    description: 'Mantenimiento preventivo y correctivo de hardware/software. Unificamos su ecosistema digital y soporte especializado en sistemas ERP.',
    icon: MonitorCheck,
    image: '/assets/service_soporte.webp',
    mobileImage: '/assets/service_soporte_movil.webp'
  },
  {
    id: 'seguridad',
    title: 'Seguridad y Accesos',
    description: 'Protección integral mediante videovigilancia avanzada (CCTV), seguridad electrónica y sistemas de control de acceso biométrico.',
    icon: ShieldCheck,
    image: '/assets/service_seguridad.webp',
    mobileImage: '/assets/service_seguridad_movil.webp'
  },
  {
    id: 'ciberseguridad',
    title: 'Ciberseguridad',
    description: 'Blindamos su información y continuidad operativa con perímetros de seguridad robustos y monitoreo proactivo contra amenazas digitales.',
    icon: LockKeyhole,
    image: '/assets/service_ciberseguridad.webp',
    mobileImage: '/assets/service_ciberseguridad_movil.webp'
  }
];

export const CREDENTIAL_LOGOS = [
  { name: 'MikroTik', logo: '/assets/credential/mikrotik.svg', url: 'https://mikrotik.com/' },
  { name: 'Microsoft', logo: '/assets/credential/microsoft.svg', url: 'https://www.microsoft.com/' },
  { name: 'HP', logo: '/assets/credential/hp.svg', url: 'https://www.hp.com/' },
  { name: 'Acronis', logo: '/assets/credential/acronis.svg', url: 'https://www.acronis.com/' },
  { name: 'Adobe Creative Cloud', logo: '/assets/credential/adobe.svg', url: 'https://www.adobe.com/creativecloud.html' },
  { name: 'Kaspersky', logo: '/assets/credential/kaspersky.svg', url: 'https://www.kaspersky.com/' },
  { name: 'Panda Segurity', logo: '/assets/credential/panda.svg', url: 'https://www.pandasecurity.com/' },
  { name: 'ZKTeco', logo: '/assets/credential/zkteco.svg', url: 'https://www.zkteco.com/' },
  { name: 'PSKloud', logo: '/assets/credential/pskloud.svg', url: 'https://premium-soft.com/us/' },
  { name: 'Hikvision', logo: '/assets/credential/hikvision.svg', url: 'https://www.hikvision.com/es-la/' },
  { name: 'VIGI', logo: '/assets/credential/vigi.svg', url: 'https://www.vigi.com/es/vigi/' },
  { name: 'Eset', logo: '/assets/credential/eset.svg', url: 'https://www.eset.com/ve/' },
  { name: 'Fortinet', logo: '/assets/credential/fortinet.svg', url: 'https://www.fortinet.com/' },
];

export const CLIENT_LOGOS = [
  { name: 'Dominos Pizza', logo: '/assets/client/dominos_pizza.svg', url: 'https://dominos.com.ve/' },
  { name: 'Mundo Total', logo: '/assets/client/mundototal.webp', url: 'https://www.tumundototal.com/' },
  { name: 'Galería Avanti', logo: '/assets/client/avanti.svg', url: 'https://galeriaavanti.com/' },
  { name: 'Budget Venezuela', logo: '/assets/client/budget_venezuela.png', url: 'https://budget.com.ve/' },
  { name: 'Softech / Profit', logo: '/assets/client/softech.svg', url: 'https://www.miprofit.com' },
  { name: 'IUTA Caracas', logo: '/assets/client/iuta.svg', url: 'https://iutacaracas.edu.ve/' },
  { name: 'Centro Médico Paso Real', logo: '/assets/client/cmpr.svg', url: 'https://www.centromedicopasoreal.com.ve/cmpr/' },
  { name: 'YPergas (Yucal Placer)', logo: '/assets/client/ypergas.png', url: 'https://ypergas.com/' },
  { name: 'Armor Group', logo: '/assets/client/armor.png', url: 'https://www.armorgroup.com.ve/' },
  { name: 'Todotractor', logo: '/assets/client/todotractor.png', url: 'https://www.todotractor.com.ve/' },
  { name: 'Compass Bank', logo: '/assets/client/compass.png', url: 'https://compass-bank.com/' },
  { name: 'Diprocher', logo: '/assets/client/diprocher.png', url: 'https://www.dipromerca.com/dipromerca/acerca-de/' },
  { name: 'Invertropoli', logo: '/assets/client/invertropoli.webp', url: 'https://www.invertropoli.com.ve/ns/' },
  { name: 'La Dolce Vita', logo: '/assets/client/la_dolce_vita.png', url: 'https://www.ladolcevitacaracas.com/' },
  { name: 'ECV & Asociados', logo: '/assets/client/ecv.png', url: 'https://www.ecv.com.ve/' },
  { name: 'Colegio Integral el Ávila', logo: '/assets/client/avila.svg', url: 'https://website.elavila.org/' },
  { name: 'Areamédica', logo: '/assets/client/areamedica.svg', url: 'https://areamedicaequipos.com/' },
];



export const CONTACT_INFO: ContactInfo = {
  address: 'Av. Francisco de Miranda, Edif. Paraguachi, P. 16, Ofic. 61. Urb. Los Ruices. Caracas – Venezuela',
  phones: ['+58 414-1967028'],
  email: 'info@stellionet.com',
  social: {
    instagram: 'https://www.instagram.com/stellionet/?hl=es',
    facebook: 'https://www.facebook.com/stellionet',
    linkedin: 'https://www.linkedin.com/company/stellionet-c-a/',
    whatsapp: 'https://wa.me/584141967028'
  }
};